import PasswordInput from "rivals/components/shared/Form/PasswordInput";
import FormInput from "rivals/components/shared/Form/TextInput";
import { InputType } from "rivals/components/shared/Form/TextInput/types";
import Link from "rivals/components/shared/Link";
import { PATHS } from "rivals/shared/constants";
import styles from "./CreateAccount.module.scss";
import strings from "./strings";
import { OwnProps } from "./types";
import Step from "../Step";

const {
  alreadyHaveAccount,
  createAnAccount,
  email,
  logIn,
  password,
  passwordRequirements,
  username,
  usernameVisibleToOthers
} = strings;

function CreateAccountStep({
  emailFeedback,
  formValues,
  handleInputChange,
  handleInputBlur,
  passwordFeedback,
  stepNumber,
  terms,
  usernameFeedback,
  userBirthdateComponent
}: OwnProps): JSX.Element {
  return (
    <Step
      stepNumber={stepNumber}
      subTitle={
        <>
          {alreadyHaveAccount}
          <Link data="sign-up-log-in-link" href={PATHS.SIGN_IN}>
            {logIn}
          </Link>
        </>
      }
      title={createAnAccount}
    >
      <>
        <FormInput
          className={styles.input}
          data="create-account-email-input"
          feedback={emailFeedback}
          htmlFor="email"
          label={email}
          onBlur={handleInputBlur}
          onChange={handleInputChange}
          required={true}
          type={InputType.TEXT}
          value={formValues.email}
        />
        <FormInput
          className={styles.input}
          data="create-account-username-input"
          feedback={usernameFeedback}
          hint={usernameVisibleToOthers}
          htmlFor="username"
          label={username}
          onBlur={handleInputBlur}
          onChange={handleInputChange}
          required={true}
          type={InputType.TEXT}
          value={formValues.username}
        />
        <PasswordInput
          className={styles.input}
          data="create-account-password-input"
          feedback={passwordFeedback}
          hint={passwordRequirements}
          label={password}
          onBlur={handleInputBlur}
          onChange={handleInputChange}
          value={formValues.password}
        />
        {userBirthdateComponent}
        {terms}
      </>
    </Step>
  );
}

export default CreateAccountStep;
